/* unplugin-vue-components disabled */import __unplugin_components_0 from '/Users/Zhuanz/Desktop/project/oral-app/src/components/Tabbar.vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "cross-container"
};
import { projectTypeApi } from "@/api/shipment";
import { doctorListApi, addApi } from "@/api/customer";
import router from "@/router";
import { showNotify } from "vant";
export default /*@__PURE__*/_defineComponent({
  __name: 'customerAdd',
  setup(__props) {
    const showPicker = ref(false);
    const showTypePicker = ref(false);
    const dataSource = ref([{
      projectName: "",
      projectInfoId: "",
      rightTop: "",
      rightBottom: "",
      leftTop: "",
      leftBottom: "",
      showPicker: false
    }]);
    const add = () => {
      dataSource.value.push({
        projectName: "",
        projectInfoId: "",
        rightTop: "",
        rightBottom: "",
        leftTop: "",
        leftBottom: "",
        showPicker: false
      });
    };
    const remove = index => {
      dataSource.value.splice(index, 1);
    };
    const customerParam = ref({
      id: "",
      name: "",
      typeName: "",
      context: "",
      age: "",
      phone: "",
      sex: "",
      tel: "",
      wx: "",
      amount: "",
      visitTime: "",
      paidInAmount: "",
      recordNum: "",
      arrearsAmount: "",
      doctorId: "",
      projectList: []
    });
    const typeColumns = [{
      text: "临时",
      value: "临时"
    }, {
      text: "普通",
      value: "普通"
    }, {
      text: "正畸",
      value: "正畸"
    }, {
      text: "活动修复",
      value: "活动修复"
    }, {
      text: "种植",
      value: "种植"
    }, {
      text: "其他",
      value: "其他"
    }];
    const doctorName = ref("");
    const showDoctorPicker = ref(false);
    const onTypeConfirm = ({
      selectedValues,
      selectedOptions
    }) => {
      showTypePicker.value = false;
      customerParam.value.typeName = selectedOptions[0]?.text;
    };
    const onDoctorConfirm = ({
      selectedValues,
      selectedOptions
    }) => {
      doctorName.value = selectedOptions[0]?.name;
      customerParam.value.doctorId = selectedOptions[0]?.id;
      showDoctorPicker.value = false;
    };
    const doctorData = ref([]);
    const projectTypeData = ref([]);
    onMounted(async () => {
      const res = await doctorListApi();
      if (res.code == 200) {
        doctorData.value = res.data ?? [];
      } else {
        showNotify({
          type: "danger",
          message: res.msg
        });
      }
      const result = await projectTypeApi();
      if (result.code == 200) {
        projectTypeData.value = result.data ?? [];
      } else {
        showNotify({
          type: "danger",
          message: result.msg
        });
      }
    });
    const loading = ref(false);
    const customFieldName = ref({
      text: "name",
      value: "id"
    });
    const fieldNames = ref({
      text: "name",
      value: "id",
      children: "children"
    });
    const onProjectInfoConfirm = (item, {
      selectedOptions
    }) => {
      item.projectName = selectedOptions[1].name; // 更新项目名称
      item.projectInfoId = selectedOptions[1].id; // 更新项目 ID
      item.showPicker = false;
    };
    const onClickLeft = () => history.back();
    const currentDate = ref(new Date());
    const onConfirm = ({
      selectedOptions
    }) => {
      showPicker.value = false;
      customerParam.value.visitTime = selectedOptions[0].value + "-" + selectedOptions[1].value + "-" + selectedOptions[2].value;
    };
    const submit = async () => {
      loading.value = true;
      const res = await addApi(param.value);
      loading.value = false;
      if (res.code == 200) {
        showNotify({
          type: "success",
          message: res.msg
        });
        router.push({
          path: "/"
        });
      } else {
        showNotify({
          type: "danger",
          message: res.msg
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_radio = _resolveComponent("van-radio");
      const _component_van_radio_group = _resolveComponent("van-radio-group");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_cascader = _resolveComponent("van-cascader");
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_date_picker = _resolveComponent("van-date-picker");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_form = _resolveComponent("van-form");
      const _component_tabbar = __unplugin_components_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_van_nav_bar, {
        title: "添加患者",
        "left-arrow": "",
        onClickLeft: onClickLeft
      }), _createVNode(_component_van_form, {
        class: "form",
        onSubmit: submit
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: _unref(customerParam).typeName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(customerParam).typeName = $event),
          "is-link": "",
          readonly: "",
          name: "picker",
          label: "患者类型",
          placeholder: "请选择患者类型",
          onClick: _cache[1] || (_cache[1] = $event => showTypePicker.value = true)
        }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
          show: _unref(showTypePicker),
          "onUpdate:show": _cache[3] || (_cache[3] = $event => _isRef(showTypePicker) ? showTypePicker.value = $event : null),
          "destroy-on-close": "",
          position: "bottom"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_picker, {
            columns: typeColumns,
            onConfirm: onTypeConfirm,
            onCancel: _cache[2] || (_cache[2] = $event => showTypePicker.value = false)
          })]),
          _: 1
        }, 8, ["show"]), _createVNode(_component_van_field, {
          modelValue: _unref(customerParam).name,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(customerParam).name = $event),
          label: "患者姓名",
          placeholder: "请输入患者姓名",
          required: "",
          clearable: "",
          rules: [{
            required: true,
            message: '请输入患者姓名',
            trigger: 'onBlur'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          name: "sex",
          label: "患者性别"
        }, {
          input: _withCtx(() => [_createVNode(_component_van_radio_group, {
            modelValue: _unref(customerParam).sex,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(customerParam).sex = $event),
            direction: "horizontal"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_radio, {
              name: 0
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("男")])),
              _: 1,
              __: [18]
            }), _createVNode(_component_van_radio, {
              name: 1
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("女")])),
              _: 1,
              __: [19]
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_van_field, {
          modelValue: _unref(customerParam).phone,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(customerParam).phone = $event),
          type: "tel",
          label: "手机号码",
          placeholder: "请输入手机号码",
          clearable: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_van_button, {
          type: "primary",
          block: "",
          onClick: add
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("添加项目")])),
          _: 1,
          __: [20]
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: item.projectInfoId
          }, [_createVNode(_component_van_field, {
            modelValue: item.projectName,
            "onUpdate:modelValue": $event => item.projectName = $event,
            label: "项目名称",
            placeholder: "请选择项目名称",
            clearable: "",
            show: item.showPicker,
            "onUpdate:show": $event => item.showPicker = $event,
            onClick: $event => item.showPicker = true,
            "is-link": "",
            readonly: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue", "show", "onUpdate:show", "onClick"]), _createVNode(_component_van_popup, {
            show: item.showPicker,
            "onUpdate:show": $event => item.showPicker = $event,
            "destroy-on-close": "",
            round: "",
            position: "bottom"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_cascader, {
              onFinish: $event => onProjectInfoConfirm(item, $event),
              onClose: $event => item.showPicker = false,
              options: _unref(projectTypeData),
              "field-names": _unref(fieldNames)
            }, null, 8, ["onFinish", "onClose", "options", "field-names"])]),
            _: 2
          }, 1032, ["show", "onUpdate:show"]), _createVNode(_component_van_field, {
            name: "tooth",
            label: "牙位信息"
          }, {
            input: _withCtx(() => [_createVNode(_component_van_cell, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_row, null, {
                default: _withCtx(() => [_createVNode(_component_van_col, {
                  span: "12"
                }, {
                  default: _withCtx(() => [_createVNode(_component_van_field, {
                    modelValue: item.rightTop,
                    "onUpdate:modelValue": $event => item.rightTop = $event,
                    type: "number",
                    class: "text-align-right",
                    placeholder: " 87654321",
                    required: "",
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024), _createVNode(_component_van_col, {
                  span: "12"
                }, {
                  default: _withCtx(() => [_createVNode(_component_van_field, {
                    modelValue: item.leftTop,
                    "onUpdate:modelValue": $event => item.leftTop = $event,
                    type: "number",
                    placeholder: "12345678",
                    required: "",
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024), _createVNode(_component_van_row, null, {
                default: _withCtx(() => [_createVNode(_component_van_col, {
                  span: "12"
                }, {
                  default: _withCtx(() => [_createVNode(_component_van_field, {
                    modelValue: item.rightBottom,
                    "onUpdate:modelValue": $event => item.rightBottom = $event,
                    type: "number",
                    class: "text-align-right",
                    placeholder: "87654321",
                    required: "",
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024), _createVNode(_component_van_col, {
                  span: "12"
                }, {
                  default: _withCtx(() => [_createVNode(_component_van_field, {
                    modelValue: item.leftBottom,
                    "onUpdate:modelValue": $event => item.leftBottom = $event,
                    type: "number",
                    placeholder: "12345678",
                    required: "",
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024)])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createVNode(_component_van_button, {
            type: "danger",
            block: "",
            onClick: $event => remove(index)
          }, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("删除")])),
            _: 2,
            __: [21]
          }, 1032, ["onClick"])]);
        }), 128)), _createVNode(_component_van_field, {
          modelValue: _unref(customerParam).amount,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(customerParam).amount = $event),
          label: "项目金额",
          placeholder: "请输入项目金额",
          required: "",
          clearable: "",
          type: "digit",
          rules: [{
            required: true,
            message: '请输入项目金额',
            trigger: 'onBlur'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: _unref(customerParam).paidInAmount,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(customerParam).paidInAmount = $event),
          label: "实收金额",
          placeholder: "请输入实收金额",
          required: "",
          type: "digit",
          clearable: "",
          rules: [{
            required: true,
            message: '请输入实收金额',
            trigger: 'onBlur'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: _unref(customerParam).arrearsAmount,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(customerParam).arrearsAmount = $event),
          label: "欠费金额",
          placeholder: "请输入欠费金额",
          type: "digit",
          clearable: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: _unref(customerParam).visitTime,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(customerParam).visitTime = $event),
          label: "初诊日期",
          placeholder: "请选择初诊日期",
          clearable: "",
          onClick: _cache[11] || (_cache[11] = $event => showPicker.value = true),
          "is-link": "",
          required: "",
          rules: [{
            required: true,
            message: '请选择初诊日期',
            trigger: 'onBlur'
          }],
          readonly: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
          show: _unref(showPicker),
          "onUpdate:show": _cache[13] || (_cache[13] = $event => _isRef(showPicker) ? showPicker.value = $event : null),
          "destroy-on-close": "",
          round: "",
          position: "bottom"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_date_picker, {
            onCancel: _cache[12] || (_cache[12] = $event => showPicker.value = false),
            onConfirm: onConfirm,
            type: "date",
            "min-date": _unref(currentDate)
          }, null, 8, ["min-date"])]),
          _: 1
        }, 8, ["show"]), _createVNode(_component_van_field, {
          modelValue: _unref(doctorName),
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _isRef(doctorName) ? doctorName.value = $event : null),
          "is-link": "",
          readonly: "",
          name: "picker",
          label: "初诊医生",
          placeholder: "请选择初诊医生",
          onClick: _cache[15] || (_cache[15] = $event => showDoctorPicker.value = true)
        }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
          show: _unref(showDoctorPicker),
          "onUpdate:show": _cache[17] || (_cache[17] = $event => _isRef(showDoctorPicker) ? showDoctorPicker.value = $event : null),
          "destroy-on-close": "",
          position: "bottom"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_picker, {
            columns: _unref(doctorData),
            onConfirm: onDoctorConfirm,
            "columns-field-names": _unref(customFieldName),
            onCancel: _cache[16] || (_cache[16] = $event => showDoctorPicker.value = false)
          }, null, 8, ["columns", "columns-field-names"])]),
          _: 1
        }, 8, ["show"]), _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [_createVNode(_component_van_button, {
            class: "btn",
            type: "primary",
            loading: _unref(loading),
            "native-type": "submit"
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("保存")])),
            _: 1,
            __: [22]
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_component_tabbar)], 64);
    };
  }
});